import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { Results } from '@local/client-contracts';
import { ResourceViewItemComponent } from '../../view-item/resource-view-item.component';

@Component({
  selector: 'app-view-item',
  templateUrl: './app-view-item.component.html',
  styleUrl: './app-view-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppViewItemComponent extends ResourceViewItemComponent {
  protected showResultSectionsDefault: Results.ShowResultSections = {
    showTags: true,
    showBullets: true,
    enableCommandBar: true,
    showSummaryAction: true,
  };

  @HostBinding('class.launcher-mode')
  get launcherMode() {
    return this.isLauncher;
  }

  getIconStyles() {
    return this.isLauncher ? { fontSize: '14px', width: '32px', height: '32px' } : { fontSize: '14px', width: '48px', height: '48px' };
  }
}
